import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {LoginService} from '../../../services/login.service';
import {ConfigService} from '../../../services/config.service';
import {first} from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import {PasswordUpdatePopupComponent} from "../../../dashboard/template/password-update-popup/password-update-popup.component";
import {MatDialog} from "@angular/material/dialog";
import {AccountSelectorPopupComponent} from "../../../dashboard/template/account-selector-popup/account-selector-popup.component";

@Component({
    selector: 'app-loginEkampus',
    templateUrl: './loginEkampus.component.html',
    styleUrls: ['./loginEkampus.component.css'],
    standalone: false
})
export class LoginEkampusComponent implements OnInit {
  protected aFormGroup: UntypedFormGroup;
  loginForm: UntypedFormGroup;
  loading = false;
  submitted = false;
  // tslint:disable-next-line:variable-name
  error_logo = false;
  returnUrl: string;
  user_profile_id: any;
  constructor(public translate: TranslateService,
              public pageTitle: Title,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private route: ActivatedRoute,
              private formBuilder: UntypedFormBuilder,
              private loginService: LoginService,
              private config: ConfigService,
              private spinner: NgxSpinnerService,
              private dialog: MatDialog) {
    translate.addLangs(['fr', 'en']);
    translate.setDefaultLang('fr');
    pageTitle.setTitle('Bienvenue sur la plateforme CertiKap');

    if (this.loginService.currentUserValue) {
      this.router.navigate(['/dashboard/administrator']);
    } else {
      this.activatedRoute.params.subscribe(params => {
        if (params.hasOwnProperty('id') && params.hasOwnProperty('token')) {
          if (params.id != '' && params.token != '') {
            this.spinner.show();
            this.loading = true;
            this.loginService.loginWithToken(params.id, params.token)
              .pipe(first())
              .subscribe(
                res => {
                  this.spinner.hide();
                  if(res.status === 'multicomptes'){
                    this.openMulticomptesDialog(res.multicomptes);
                  }
                  else if (res.status === 'success') {
                    localStorage.setItem('profile_id', res.profile_id);
                    localStorage.setItem('site_id', res.site_id);
                    if (res.profile_id === 10 || res.profile_id === 8) {
                      window.location.reload();
                      this.router.navigate(['dashboard/inspector']);
                      return false;
                    }
                    window.location.reload();
                    this.router.navigate(['dashboard/administrator']);
                    return false;
                  }
                },
                error => {
                  this.spinner.hide();
                  this.error_logo = true;
                  this.loading = false;
                });
          }
        }
      });
    }

  }

  ngOnInit() {
    if (localStorage.getItem('currentUser')) {
      this.router.navigate([this.returnUrl]);
    } else {
      this.loginForm = this.formBuilder.group({
        email: ['', Validators.required],
        password: ['', Validators.required]
      });
    }

    this.aFormGroup = this.formBuilder.group({
      recaptcha: ['', Validators.required]
    });
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/dashboard/inspector';
  }
  switchLang(lang: string) {this.translate.use(lang); }
  get f() { return this.loginForm.controls; }

  login() {
    this.submitted = true;
    this.spinner.show();

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.spinner.hide();
      return;
    }
    this.loading = true;
    this.loginService.login(this.f.email.value, this.f.password.value)
      .pipe(first())
      .subscribe(
        res => {
          this.spinner.hide();
          this.error_logo = false;
          if(res.status === 'multicomptes'){
            this.openMulticomptesDialog(res.multicomptes);
          }
          else if (res.status === 'success') {
            if(res.change_password == 1){
              this.openPasswordUpdatePopup(res);
            }else{
              localStorage.setItem('profile_id', res.profile_id);
              localStorage.setItem('site_id', res.site_id);
              if (res.profile_id === 10 || res.profile_id === 8) {
                window.location.reload();
                this.router.navigate(['dashboard/inspector']);
                return false;
              }
              window.location.reload();
              this.router.navigate(['dashboard/administrator']);
              return false;
            }
          }
        },
        error => {
          this.spinner.hide();
          this.error_logo = true;
          this.loading = false;
        });
  }

  // tslint:disable-next-line:variable-name
  redirectToAdmin(profile_id)  {
    switch (profile_id) {
      case 10: {
        this.router.navigate(['dashboard/inspector']);
        break;
      }
      case 9: {
        this.router.navigate(['dashboard/administrator']);
        break;
      }

    }
  }


  openPasswordUpdatePopup(user): void {
    // Ouvrir le popup avec MatDialog
    const dialogRef = this.dialog.open(PasswordUpdatePopupComponent, {
      width: '400px',
      disableClose: true, // Empêcher la fermeture en cliquant à côté
      data: {
        currentUser: user,
        tokenCurrentConnected: user.token,
        site_id: user.site_id,
        profile_id: user.profile_id,
      }
    });

    // Vous pouvez gérer la fermeture du dialogue et les actions de retour avec `afterClosed`
    dialogRef.afterClosed().subscribe(result => {
      console.log('Popup fermé, résultat :', result);
    });
  }


  // Méthode pour ouvrir la pop-up
  openMulticomptesDialog(multicomptes: any[]) {
    const dialogRef = this.dialog.open(AccountSelectorPopupComponent, {
      width: '600px',
      height: 'auto',  // Hauteur automatique en fonction du contenu
      data: { multicomptes: multicomptes }
    });

    dialogRef.afterClosed().subscribe(selectedCompte => {
      if (selectedCompte) {
        // Si un compte a été sélectionné, tu peux gérer la redirection ici
        this.switchAccount(selectedCompte);
      }
    });
  }

  switchAccount(User :any){
    this.spinner.show();
    this.loginService.switchAccount(User.login)
      .subscribe(res => {
        if (res.status == 'success') {
          this.spinner.hide();
          localStorage.setItem('profile_id', res.profile_id);
          localStorage.setItem('site_id', res.site_id);
          if (res.profile_id === 10 || res.profile_id === 8) {
            window.location.reload();
            this.router.navigate(['dashboard/inspector']);
            return false;
          }
          window.location.reload();
          this.router.navigate(['dashboard/administrator']);
          return false;
        }
      }, (err) => {
        this.spinner.hide();
        console.log(err);
      });
  }

}
